import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { movies } from "@/mocks/movies";
import Hero from "./components/Hero";
import SpotlightCarousel from "./components/SpotlightCarousel";
import CategoryTiles from "./components/CategoryTiles";
import MovieGridSection from "./components/MovieGridSection";
import RankingSection from "./components/RankingSection";
import AboutStrip from "./components/AboutStrip";

const editorsPicks = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);
const latest = [...movies]
  .filter((movie) => movie.collection.includes("new"))
  .sort((a, b) => b.year - a.year)
  .slice(0, 4);

export default function Home() {
  usePageMeta(
    "韩国三级电影大全_热门韩国三级电影推荐与解析",
    "韩国三级电影提供丰富的韩国三级影视作品介绍和评论，涵盖热门影片及经典作品，满足用户了解韩国三级电影的需求。",
    "韩国三级电影,亚洲三级电影,韩国三级片介绍,韩国电影资源,韩国电影解析,三级电影推荐,韩国影视大全。",
  );

  return (
    <SiteLayout>
      <Hero />
      <SpotlightCarousel />
      <CategoryTiles />
      <MovieGridSection
        eyebrow="Editor's selection"
        title="精选影片"
        desc="综合剧情完成度、镜头语言与讨论热度选出的八部作品，适合作为进入这个题材的起点。"
        movies={editorsPicks}
        actionTo="/category"
        actionLabel="查看全部影片"
      />
      <RankingSection />
      <MovieGridSection
        eyebrow="Newly added"
        title="最新收录"
        desc="近期整理完成的新片资料，包含剧情概要、主创信息与编辑解析。"
        movies={latest}
        actionTo="/category?c=new"
        actionLabel="更多新片"
        showDesc
      />
      <AboutStrip />
    </SiteLayout>
  );
}